import type { UseFetchOptions } from "nuxt/app";

export function mainFetch(uri: string, opts: UseFetchOptions<any> = {}, onlyClient: boolean = false) {
  return useFetch(uri, {
    ...opts,
    $fetch: useNuxtApp().$mainFetch
  });
}